var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "m8.3 6.28 4.49 4.39c.2.19.2.5 0 .7L8.55 15.7a1 1 0 0 1-.71.3H6.6a.25.25 0 0 1-.17-.43l4.53-4.53-4.54-4.61A.25.25 0 0 1 6.6 6h1a1 1 0 0 1 .7.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "m12.3 6.28 4.49 4.39c.2.19.2.5 0 .7l-4.25 4.33a1 1 0 0 1-.71.3H10.6a.25.25 0 0 1-.17-.43l4.53-4.53-4.54-4.61A.25.25 0 0 1 10.6 6h1a1 1 0 0 1 .7.28"
  })));
};
export default SvgLinkIcon;